import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'sr';
    document.title = 'КОШАРКА СПРЕМНА™ – Цела сезона тренинга за тренере кошарке (6–16 година)';
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3mjq27fl7ksv2">
      <div lang="sr" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="3rcj7q5oi4587">
        <CountdownBar data-id="element-2" data-mp="5yhupa6n3cr" />
        <main data-id="element-3" data-mp="67znpl2q47d">
          <Hero data-id="element-4" data-mp="4wyzymxdckh" />
          <StatsBar data-id="element-5" data-mp="5ggxfcks0yi" />
          <Difference data-id="element-6" data-mp="7su7f7e1n58" />
          <Recognize data-id="element-7" data-mp="2zld2jatxbhc2" />
          <WhatsInside data-id="element-8" data-mp="2zlv32jnmchps" />
          <InsidePages data-id="element-9" data-mp="2zmo6pbra6r3p" />
          <Bonuses data-id="element-10" data-mp="2zng14j956ise" />
          <HowItWorks data-id="element-11" data-mp="33mf2jtvnzxf3" />
          <Audience data-id="element-12" data-mp="33lx0uhq8gqzs" />
          <Offer data-id="element-13" data-mp="33n6zb810016y" />
          <Guarantee data-id="element-14" data-mp="33orhrza1ftog" />
          <Testimonials data-id="element-15" data-mp="38lrqkhy9vaj9" />
          <Faq data-id="element-16" data-mp="38li8rhnds9on" />
          <FinalCta data-id="element-17" data-mp="38l04bxqkep5n" />
        </main>
        <Footer data-id="element-18" data-mp="38nupxslbeg0n" />
      </div>
    </MotionConfig>;
}